module.exports = __webpack_public_path__ + "img/qrcode.sales.06be8845.png";